/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import * as React from 'react';
import { PublicRoutePath } from 'routes/paths';
import { useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { Ducks } from '@wit/vtv-x-foundation-lib';
import translate from '../../../services/i18n/translate';

const SelectPage: React.FunctionComponent = () => {
  const history = useHistory();

  // Consent and Notice GDPR Links
  const gdprData = useSelector(Ducks.Faqs.Selectors.getGdprData);
  const { notice, consent } = gdprData?.documents || {};
  // Go to consent
  if (consent && !notice) {
    history.replace(PublicRoutePath.PRIVACY_CONSENT);
  }
  // Go to notice
  if (!consent && notice) {
    history.replace(PublicRoutePath.PRIVACY_NOTICE);
  }

  return (
    <div id="PrivacyPage" className="component-inner component-inner-settings settings-template ">
      <h2 id="PrivacyPage_title">{translate['gdpr.main.title']}</h2>
      <p id="PrivacyPage_subtitle">{translate['gdpr.main.subtitle']}</p>
      <ul id="PrivacyPage_list" className="settings-list">
        <li>
          <div id="PrivacyPage_noticeTitle" className="group-item-title">
            {translate['gdpr.main.notice.title']}
          </div>
          <div className="settings-link">
            <Link id="PrivacyPage_noticeLink" to={PublicRoutePath.PRIVACY_NOTICE}>
              <span className="text-link">{translate['gdpr.main.notice.link']}</span>
            </Link>
          </div>
        </li>
        <li>
          <div id="PrivacyPage_consentTitle" className="group-item-title">
            {translate['gdpr.main.consent.title']}
          </div>
          <div className="settings-link">
            <Link id="PrivacyPage_consentLink" to={PublicRoutePath.PRIVACY_CONSENT}>
              <span className="text-link">{translate['gdpr.main.consent.link']}</span>
            </Link>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default SelectPage;
